import types from './types';

export default {
  [types.SET_MODULES_HML_VERSION](state, modulesHMLVersion) {
    state.modulesHMLVersion = modulesHMLVersion;
  },
};
